import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import banner1 from "../assets/images/contact.png";
import UnderCons from "../assets/images/underconstruction.png";
import "remixicon/fonts/remixicon.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";

const INITIAL_FORM = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  message: "",
};

const Contact = () => {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [subjects, setSubjects] = useState({
    recruiter: false,
    aggregators: false,
  });
  const [submitting, setSubmitting] = useState(false);
  const [ipAddress, setIpAddress] = useState("");

  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setIpAddress(response.data.ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
        setIpAddress("Unable to fetch IP");
      }
    };
    fetchIpAddress();
  }, []);

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  // Recruiter Inquiry and Aggregators Inquiry are mutually exclusive — picking one
  // clears the other, so checking both at once (both booleans true) can't happen.
  const handleSubjectChange = (key) => (e) => {
    const checked = e.target.checked;
    setSubjects({
      recruiter: key === 'recruiter' ? checked : false,
      aggregators: key === 'aggregators' ? checked : false,
    });
  };

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (!formData.firstName.trim() || !formData.lastName.trim()) {
      toast.error("Please enter your first and last name");
      return false;
    }
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address");
      return false;
    }
    if (!phoneRegex.test(formData.phone)) {
      toast.error("Phone number must be exactly 10 digits");
      return false;
    }
    if (!subjects.recruiter && !subjects.aggregators) {
      toast.error("Please select at least one subject");
      return false;
    }
    if (!formData.message.trim()) {
      toast.error("Please enter a message");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const selectedSubjects = [
      subjects.recruiter ? "Recruiter Inquiry" : null,
      subjects.aggregators ? "Aggregators Inquiry" : null,
    ].filter(Boolean);

    const payload = {
      id: 0,
      name: `${formData.firstName.trim()} ${formData.lastName.trim()}`.trim(),
      email: formData.email,
      phone: formData.phone,
      message: formData.message,
      type: selectedSubjects.join(", "),
      ipAddress: ipAddress,
      macAddress: "string",
      website: "guideuni.com",
      createdOn: new Date().toISOString(),
      isActive: true,
    };

    console.log("before", payload);

    setSubmitting(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/AddFlyurdreamEnquiry`,
        payload
      );
      toast.success(response.data.message || "Message sent successfully!");
      setFormData(INITIAL_FORM);
      setSubjects({ recruiter: false, aggregators: false });
      console.log("after", response.data);
    } catch (error) {
      toast.error("Error submitting enquiry. Please try again.");
      console.error("Enquiry submit failed:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div className="banner-two banner-aggregators">
        <img src={banner1} alt="Contact" />
      </div>

      <div className="banner-bottom">
        <div className="container-fluid">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center banner-bottom-text">
                <h4>Contact</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid mt-10 mb-10">
        <div className="container">
          <div className="row">
            {/* Contact Info */}
            <div className="col-md-4 col-sm-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="contact-info-box">
                    <h4>Contact Information</h4>
                    <p>Say something to start a live chat!</p>
                    <br />
                    <br />
                    <address>
                      <i className="ri-phone-line"></i>{" "}
                      <a href="tel:+10123456789">+1 012 3456 789</a>
                      <br />
                      <br />
                      <i className="ri-mail-line"></i>{" "}
                      <a href="mailto:demo@gmail.com">demo@gmail.com</a>
                      <br />
                      <br />
                      <i className="ri-map-pin-line"></i>  Vista Business Centre, 50 Salisbury Road, Hounslow, Middlesex, United Kingdom
                    </address>
                  </div>
                </div>
              </div>
            </div>

            {/* Form */}
            <div className="col-md-8 col-sm-12">
              <form className="c-floating-form" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 col-sm-12">
                    <div className="form-floating mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id="floatingFirstName"
                        placeholder="First Name"
                        value={formData.firstName}
                        onChange={handleChange("firstName")}
                      />
                      <label htmlFor="floatingFirstName">First Name</label>
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-12">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="floatingLastName"
                        placeholder="Last Name"
                        value={formData.lastName}
                        onChange={handleChange("lastName")}
                      />
                      <label htmlFor="floatingLastName">Last Name</label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-sm-12">
                    <div className="form-floating mb-3">
                      <input
                        type="email"
                        className="form-control"
                        id="Email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange("email")}
                      />
                      <label htmlFor="Email">Email</label>
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-12">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="Phone"
                        placeholder="Phone"
                        value={formData.phone}
                        onChange={handleChange("phone")}
                        maxLength={10}
                      />
                      <label htmlFor="Phone">Phone</label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <h6>Select Subject?</h6>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="inlineCheckbox1"
                        value="option1"
                        checked={subjects.recruiter}
                        onChange={handleSubjectChange("recruiter")}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineCheckbox1"
                      >
                        Recruiter Inquiry
                      </label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="inlineCheckbox2"
                        value="option2"
                        checked={subjects.aggregators}
                        onChange={handleSubjectChange("aggregators")}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineCheckbox2"
                      >
                        Aggregators Inquiry
                      </label>
                    </div>

                    {/* Example disabled checkbox */}
                    {/*
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="inlineCheckbox3"
                        value="option3"
                        disabled
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineCheckbox3"
                      >
                        3 (disabled)
                      </label>
                    </div>
                    */}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <div className="form-floating mb-3">
                      <textarea
                        className="form-control"
                        id="Message"
                        rows={10}
                        placeholder="Message"
                        value={formData.message}
                        onChange={handleChange("message")}
                      ></textarea>
                      <label htmlFor="Message">Message</label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 col-sm-12 text-end">
                    <button type="submit" className="btn cff-send" disabled={submitting}>
                      {submitting ? "Sending..." : "Send Message"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default Contact;